import { useAuthSelector } from 'app/data/auth';
import omniQueryKeys from 'app/hooks/queries/omni/omniQueryKeys';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
// import { CallDetailRecordsPageResponse } from 'types/callDetailRecord';

export const useOmniQuery = (search: string) => {
  // returns list of callDetailRecords
  // - just get ALL callDetailRecords+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = omniQueryKeys.search(search);

  const query = useQuery<any, Error>(
    queryKey,
    () =>
      sdk.omni.query.search(
        {
          search,
        },
        { authToken: authState.auth_token },
      ),
    {
      enabled: search?.length ? true : false, //authState?.auth_token_decoded?.owner_id ? true : false,
      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      // keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useOmniQuery;
